import { useRecoilState, useSetRecoilState } from "recoil";
import { useCallback, useEffect, useMemo } from "react";
import useEffectSkipFirst from "../../../hooks/useEffectSkipFirst";
import { mapContentsVisibleWithID } from "../../../store/MapContentsState";
import { addMapLegendSelector, removeMapLegendSelector } from "../../../store/MapLegendState";
import { useAlert } from "../../../hooks/useAlert";
import { useExecutePreMount } from "../../../hooks/useExecutePreMount";
import { removeDuplicateMessagesSelector } from "../../../store/AlertState";
import { makeErrorMessage } from "../../../utils/ErrorMessageUtil";

function ContentsDispatcher({contentsID, contents}) {
  const [visible, setVisible] = useRecoilState(mapContentsVisibleWithID(contentsID));
  const dependency = useMemo(() => ([visible]), [visible]);
  const addMapLegend = useSetRecoilState(addMapLegendSelector);
  const removeMapLegend = useSetRecoilState(removeMapLegendSelector);
  const {showError, removeAlert} = useAlert();
  const setRemoveDuplicateMessages = useSetRecoilState(removeDuplicateMessagesSelector);
  const dispatcher = useCallback(action => {
    if (action.type === 'SHOW_ERROR') {
      const errorMessage = makeErrorMessage(action.payload);
      setRemoveDuplicateMessages(errorMessage);
      return showError(errorMessage);
    } else if (action.type === 'CLEAR_ERROR') {
      if (action.payload) {
        removeAlert(action.payload);
      }
    }
  }, [setRemoveDuplicateMessages, showError, removeAlert]);

  useExecutePreMount(() => {
    if (contents.setContentsDispatcher) {
      contents.setContentsDispatcher(dispatcher);
    }
  });

  useEffect(() => {
    if (visible) {
      contents.drawLayer(visible);
      //selectedMapContentsListを更新するため
      setVisible(true);
      if (typeof contents.getLegend === 'function') {
        addMapLegend(contents.getLegend());
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffectSkipFirst(async() => {
    await contents.drawLayer(visible);

    if (typeof contents.getLegend === 'function') {
      if (visible) {
        addMapLegend(contents.getLegend());
      } else {
        removeMapLegend(contents.getLegend());
      }
    }
  }, dependency);

  //dont draw anything
  return null;
}

export default ContentsDispatcher